import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { installI18n } from './i18n'
import './style.css'

// Lightweight Web-Vitals reporter (mimics diagnostic-web-vitals bundle)
import { onLCP, onINP, onCLS, onFCP, onTTFB } from 'web-vitals'
const report = (m) => console.info(`[vitals] ${m.name}=${m.value.toFixed ? m.value.toFixed(0) : m.value}`)
;[onLCP, onINP, onCLS, onFCP, onTTFB].forEach(fn => fn(report))

const app = createApp(App)
installI18n(app)
app.use(router).mount('#app')
